<template>
	<div>
		<!-- 桌面端：顶部导航（mdAndUp，原样保留） -->
		<v-app-bar light v-if="$vuetify.breakpoint.mdAndUp">
			<v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

			<v-toolbar-title @click="changePage('/')" style="cursor:pointer">海鸥系统</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-btn icon @click="changePage('/user')">
				<v-icon>mdi-account</v-icon>
			</v-btn>

			<v-btn icon>
				<v-icon @click="logout()">mdi-logout</v-icon>
			</v-btn>

		</v-app-bar>

		<!-- 移动端：底部导航（xsOnly） -->
		<v-bottom-navigation v-else-if="$vuetify.breakpoint.xsOnly" v-model="bottomNav" app grow background-color="white"  color="primary">
			<v-btn value="/" @click="changePage('/')">
				<span>首页</span>
				<v-icon>mdi-home</v-icon>
			</v-btn>
			<v-btn value="/quotation" @click="changePage('/quotation')">
				<span>报价</span>
				<v-icon>mdi-cash-100</v-icon>
			</v-btn>
			<v-btn value="/order" @click="changePage('/order')">
				<span>订单</span>
				<v-icon>mdi-order-bool-ascending-variant</v-icon>
			</v-btn>
			<v-btn value="/user" @click="changePage('/user')">
				<span>我的</span>
				<v-icon>mdi-account</v-icon>
			</v-btn>
		</v-bottom-navigation>

		<v-navigation-drawer v-model="drawer" absolute temporary>
			<v-list nav dense>
				<v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">

					<v-list-item @click="changePage('/')">
						<v-list-item-icon>
							<v-icon>mdi-home</v-icon>
						</v-list-item-icon>
						<v-list-item-title>首页</v-list-item-title>
					</v-list-item>

					<v-list-item @click="changePage('/quotation')">
						<v-list-item-icon>
							<v-icon>mdi-cash-100</v-icon>
						</v-list-item-icon>
						<v-list-item-title>报价</v-list-item-title>
					</v-list-item>

					<v-list-item @click="changePage('/order')">
						<v-list-item-icon>
							<v-icon>mdi-order-bool-ascending-variant</v-icon>
						</v-list-item-icon>
						<v-list-item-title>订单</v-list-item-title>
					</v-list-item>


					<v-list-item @click="changePage('/admin')" v-if="isAdmin">
						<v-list-item-icon>
							<v-icon>mdi-account</v-icon>
						</v-list-item-icon>
						<v-list-item-title>系统管理</v-list-item-title>
					</v-list-item>

				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
	export default {
		methods: {
			changePage(url) {
				this.$router.push(url);
			},
			logout() {
				this.$axios.post('/kt-supplier/logout').then(res => {
					if (res.data.state == 200) {
						localStorage.removeItem('authToken');
						localStorage.removeItem("venderId");
						this.$router.push('/login');
					}
				});
			}
		},
		data: () => ({
			drawer: false,
			group: null,
			isAdmin: false,
			bottomNav: '/'
		}),
		watch: {
			// 路由变化时同步底部导航高亮（含浏览器前进后退/直接输入地址）
			'$route.path'(path) {
				this.bottomNav = path;
			}
		},
		created() {
			this.bottomNav = this.$route.path;
			let menu = JSON.parse(localStorage.getItem("menu"));
			menu.forEach(item => {
				if (item.funcLangCode === "用户管理") {
					this.isAdmin = true;
				}
			})
		}
	}
</script>

<style>
	.el-menu-demo {
		display: flex;
		justify-content: space-around;
		/* 菜单项水平排列，间距均匀 */
		width: 100%;
	}

	@media (max-width: 768px) {
		.el-menu-demo {
			justify-content: center;
			/* 在小屏幕上，菜单项居中 */
		}
	}

	@media (max-width: 480px) {
		.el-menu-demo {
			flex-direction: column;
			/* 在更小屏幕上，菜单项垂直排列 */
		}
	}
</style>